export const DEFAULT_STYLE_FILE_NAME = `styles-onetrust.scss`
